import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { ExternalLink } from '@/components/ui/ExternalLink';

const TRF_SUPPORT_URL = 'https://www.trf.org/get-support';

/**
 * #2199 — shown in place of the wizard's step when TRF has closed the platform
 * to Canadian families (`features.canada_intake_closed`) and this family's
 * Region is Canada. Calm, full width, no Continue: nothing is submitted past it.
 *
 * `onChangeAnswer` is offered when the family picked Canada on this visit, so
 * one who picked it by mistake can go back to the Region question. A renewal
 * whose family record is Canadian gets no way back.
 */
export function CanadaIntakeClosedNotice({ onChangeAnswer }: { onChangeAnswer?: () => void }) {
  const { t } = useTranslation(['forms', 'common']);
  return (
    <div
      data-testid="canada-intake-closed"
      role="status"
      className="w-full space-y-3 rounded-lg border border-stevens-rule bg-stevens-bg-2 p-6"
    >
      <h1 className="flex items-start gap-2 font-serif text-title font-normal leading-snug tracking-tight text-foreground">
        <span>{t('forms:wizard.canadaClosedTitle')}</span>
      </h1>
      <p className="m-0 text-body text-stevens-ink-2">{t('forms:wizard.canadaClosedBody')}</p>
      <p className="m-0 text-body">
        <ExternalLink
          href={TRF_SUPPORT_URL}
          className="text-stevens-ink underline decoration-stevens-indigo/40 underline-offset-4 transition-colors hover:text-stevens-indigo hover:decoration-stevens-indigo"
        >
          trf.org/get-support
        </ExternalLink>
      </p>
      {onChangeAnswer && (
        <div className="pt-2">
          <Button variant="ghost" onClick={onChangeAnswer} className="text-stevens-ink-3">
            {t('common:actions.back')}
          </Button>
        </div>
      )}
    </div>
  );
}
